<div class="row mx-0 my-3 my-xl-0 d-flex align-items-center min-vh-100">
	<div class="col-lg-12">
		<div class="titolo text-center">
			<span
				*ngIf="!authService.isLogged"
				class="text-pink cursor-pointer top-left-position"
				(click)="location.back()"
			>
				<i class="fas fa-chevron-left mr-2 text-pink"></i>
				Back to login
			</span>
			<img
				*ngIf="!authService.isLogged"
				src="./assets/imgs/logo_open_fiber_magenta.png?v={{ assets_version }}"
				srcset="./assets/imgs/logo_open_fiber_magenta@2x.png 2x"
				class="d-block mx-auto mb-4"
			/>
			<p [class]="!isLogged ? 'logged-title' : ''">Open an issue</p>
		</div>
		<div [class]="!isLogged ? 'logged-box' : ''">
			<form class="row d-flex justify-content-center align-items-center" #form="ngForm">
				<div class="col-12"></div>
				<div [class]="!isLogged ? 'col-12 px-5' : 'col-12 col-lg-6 px-4'">
					<span class="w-100 box-label">Issue type</span>
					<div class="form-row position-relative w-100 mx-0">
						<mat-form-field appearance="outline" class="w-100">
							<mat-select
								placeholder="Issue Type"
								[formControl]="issue_type"
								(selectionChange)="resetError()"
							>
								<mat-option *ngFor="let option of optionsList" [value]="option">
									{{ option }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<div class="box d-flex justify-content-center align-items-center">
							<i class="fas fa-chevron-down"></i>
						</div>
					</div>

					<ng-container *ngIf="!authService.isLogged">
						<div class="row">
							<div class="col-md-6">
								<span class="w-100 box-label">Name</span>
								<mat-form-field appearance="outline" class="w-100">
									<input
										matInput
										type="text"
										[(ngModel)]="errorReport.name"
										placeholder="Name"
										name="name"
									/>
								</mat-form-field>
							</div>
							<div class="col-md-6">
								<span class="w-100 box-label">Surname</span>
								<mat-form-field appearance="outline" class="w-100">
									<input
										matInput
										type="text"
										[(ngModel)]="errorReport.surname"
										placeholder="Surname"
										name="surname"
									/>
								</mat-form-field>
							</div>
						</div>
						<span class="w-100 box-label">Email</span>
						<mat-form-field appearance="outline" class="w-100">
							<input
								matInput
								type="email"
								[(ngModel)]="errorReport.email"
								placeholder="Email"
								required
								name="email"
								(input)="resetError()"
							/>
						</mat-form-field>
					</ng-container>

					<span class="w-100 box-label">Subject</span>
					<mat-form-field appearance="outline" class="w-100">
						<input
							matInput
							type="text"
							[(ngModel)]="errorReport.subject"
							placeholder="Subject"
							required
							name="subject"
							(input)="resetError()"
						/>
					</mat-form-field>

					<span class="w-100 box-label">Body</span>
					<mat-form-field appearance="outline" class="w-100">
						<textarea
							rows="5"
							matInput
							type="text"
							[(ngModel)]="errorReport.body"
							required
							placeholder="Body"
							name="body"
							(input)="resetError()"
						></textarea>
					</mat-form-field>

					<span class="w-100 box-label">Files</span>
					<div class="form-row position-relative w-100 mx-0">
						<mat-form-field
							appearance="outline"
							class="w-100 bg-disabled-white"
							[class.input-filled]="fileNames && fileNames.length > 0"
						>
							<input matInput disabled placeholder="Select files" [value]="fileNamesToDisplay" />
						</mat-form-field>
						<button
							mat-stroked-button
							class="btn pt-2 pb-2 d-flex justify-content-center align-items-center btn-box"
							(click)="fileInput.click()"
						>
							<span>Add Files</span>
						</button>
					</div>

					<div *ngIf="errorMessage" class="d-flex justify-content-center text-danger my-4 errorMessage">
						{{ errorMessage }}
					</div>
				</div>
			</form>
			<div class="w-100 d-flex justify-content-center align-items-center">
				<input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file" multiple="multiple" />
				<span (click)="clear()" class="clear-btn cursor-pointer mt-3 mr-4">Clear files</span>
				<button
					mat-stroked-button
					[disabled]="disabled"
					class="btn pt-2 pb-2 mt-3 d-block submit-btn"
					(click)="onSubmit()"
				>
					<mat-spinner *ngIf="waitSubmit"></mat-spinner>
					<span *ngIf="!waitSubmit">Submit</span>
				</button>
			</div>
		</div>
	</div>
</div>
